import { ContactData, EmailData } from '../../../domain/document.model';
import { Offer, OfferRequest, PolicyholderRequest } from '../../../domain/offer.domain';
import { Party } from '../../../domain/party.domain';
import {
    Cession,
    InsuredProduct,
    InsuredProductFrontier,
    InsuredProductMotor,
    InsuredProductProperty
} from '../../../domain/product.domain';

export namespace OfferAction {
    export class CreateCalculation {
        static readonly type = 'OfferAction.Create';

        constructor(public request: OfferRequest) {
        }
    }

    export class PatchOfferState {
        static readonly type = 'OfferAction.PatchOfferState';

        constructor(public offer: Offer) {
        }
    }

    export class GetOne {
        static readonly type = 'OfferAction.GetOne';

        constructor(public id: number) {
        }
    }

    export class EditPolicyholder {
        static readonly type = 'OfferAction.EditPolicyholder';

        constructor(public id: number, public policyholder: PolicyholderRequest) {
        }
    }

    export class SavePolicyholder {
        static readonly type = 'OfferAction.SavePolicyholder';

        constructor(public id: number, public policyholder: PolicyholderRequest) {
        }
    }

    export class EditInsured {
        static readonly type = 'OfferAction.EditInsured';

        constructor(public id: number, public party: Party) {
        }
    }

    export class SaveInsured {
        static readonly type = 'OfferAction.SaveInsured';

        constructor(public id: number, public party: Party) {
        }
    }

    export class DeleteInsured {
        static readonly type = 'OfferAction.DeleteInsured';

        constructor(public id: number, public party: Party) {
        }
    }

    export class CreateProductProperty {
        static readonly type = 'OfferAction.CreateProductProperty';

        constructor(public id: number) {
        }
    }

    export class ValidationPropertyBasic {
        static readonly type = 'OfferAction.ValidationPropertyBasic';

        constructor(public offerId: number, public product: InsuredProductProperty) {
        }
    }

    export class CalculateProperty {
        static readonly type = 'OfferAction.CalculateProperty';

        constructor(public offerId: number, public product: InsuredProductProperty) {
        }
    }

    export class SaveProperty {
        static readonly type = 'OfferAction.SaveProperty';

        constructor(public offerId: number, public product: InsuredProductProperty) {
        }
    }

    export class CreateProductMotor {
        static readonly type = 'OfferAction.CreateProductMotor';

        constructor(public id: number) {
        }
    }

    export class ValidationMotorBasic {
        static readonly type = 'OfferAction.ValidationMotorBasic';

        constructor(public offerId: number, public product: InsuredProductMotor) {
        }
    }

    export class ValidationMotorClaims {
        static readonly type = 'OfferAction.ValidationMotorClaims';

        constructor(public offerId: number, public product: InsuredProductMotor) {
        }
    }

    export class CalculateMotor {
        static readonly type = 'OfferAction.CalculateMotor';

        constructor(public offerId: number, public product: InsuredProductMotor) {
        }
    }


    export class SaveMotor {
        static readonly type = 'OfferAction.SaveMotor';

        constructor(public offerId: number, public product: InsuredProductMotor) {
        }
    }

    export class DeleteProduct {
        static readonly type = 'OfferAction.DeleteProducts';

        constructor(public id: number, public productId: number) {
        }
    }

    export class SaveLocation {
        static readonly type = 'OfferAction.SaveLocation';

        constructor(public calculationId: number, public location: string) {
        }
    }

    export class SaveContactData {
        static readonly type = 'OfferAction.SaveContactData';

        constructor(public calculationId: number, public data: ContactData) {
        }
    }

    export class SaveEmailDataForIOffer {
        static readonly type = 'OfferAction.SaveEmailDataForIOffer';

        constructor(public calculationId: number, public data: EmailData) {
        }
    }

    export class DeleteContactData {
        static readonly type = 'OfferAction.DeleteContactData';

        constructor(public calculationId: number) {
        }
    }

    export class CreateOffer {
        static readonly type = 'OfferAction.CreateOffer';

        constructor(public offer: Offer) {
        }
    }

    export class IssueFromCalculation {
        static readonly type = 'OfferAction.IssueFromCalculation';

        constructor(public offer: Offer) {
        }
    }

    export class OpenCessionAside {
        static readonly type = 'OfferAction.OpenCessionAside';

        constructor(public insuredProduct: InsuredProduct) {
        }
    }

    export class SaveCession {
        static readonly type = 'OfferAction.SaveCession';

        constructor(public calculationId: number, public productId: number, public data: Cession) {
        }
    }

    export class DeleteCession {
        static readonly type = 'OfferAction.DeleteCession';

        constructor(public calculationId: number, public productId: number) {
        }
    }

    export class BackToCalculation {
        static readonly type = 'OfferAction.BackToCalculation';

        constructor(public offerId: number) {
        }
    }

    export class ReadonlyMotor {
        static readonly type = 'OfferAction.ReadonlyMotor';

        constructor(public product: InsuredProductMotor) {
        }
    }

    export class ReadonlyProperty {
        static readonly type = 'OfferAction.ReadonlyProperty';

        constructor(public product: InsuredProductProperty) {
        }
    }

    export class ReadonlyFrontier {
        static readonly type = 'OfferAction.ReadonlyFrontier';

        constructor(public product: InsuredProductFrontier) {
        }
    }

    export class PrintoutCalculation {
        static readonly type = 'OfferAction.PrintoutCalculation';

        constructor(public id: number, public productId: number, public all: boolean) {
        }
    }

    export class PrintoutOffer {
        static readonly type = 'OfferAction.PrintoutOffer';

        constructor(public id: number, public productId: number, public all: boolean) {
        }
    }

    export class Issue {
        static readonly type = 'OfferAction.Issue';

        constructor(public id: number) {
        }
    }

    export class IssueReal {
        static readonly type = 'OfferAction.IssueReal';

        constructor(public id: number) {
        }
    }

    export class CreateIOffer {
        static readonly type = 'OfferAction.CreateIOffer';

        constructor(public id: number) {
        }
    }
}
